
if (!window.customElements.get('gtc-accordion-item')) {
    class GtcAccordionItem extends HTMLElement {
        static get observedAttributes() {
            return ['open'];
        }

        // Add any initialization code here
        constructor() {
            super();
            this.dom = {
                trigger: null,
                content: null
            };

            this.settings = {
                id: this.getAttribute('id'),
                groupId: this.getAttribute('group-id'),
                ariaControlsId: this.querySelector('[aria-controls]')?.getAttribute('aria-controls'),
                setOpenParam: true,
                clickOutsideClose: true,
                animationDuration: 300,
                animationOpenTimeout: null,
                animationCloseTimeout: null,
                scrollTo: false
            }
        }

        // Add code to run when the element is inserted into the DOM
        connectedCallback() {

            this.SetA11yAttributes();

            if (this.hasAttribute('single')) {
                this.setAttribute('aria-multiselectable', 'false');
                this.settings.groupId = true;
            }
            else {
                this.setAttribute('aria-multiselectable', 'true');
            }

            if (this.settings.scrollTo) {
                this.setAttribute('aria-expanded', 'true');
                this.settings.scrollTo = false;
                if (history.scrollRestoration) {
                    history.scrollRestoration = "manual";
                }
                this.scrollIntoView({ behavior: 'smooth' });
            }


            this.checkOpenCookie();

            this.AddEventListeners();
        }

        // Add code to run when the element is removed from the DOM
        disconnectedCallback() {
            this.RemoveEventListeners();
        }

        // Update the element
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'open') {

                // This is placed here to ensure that the animation duration is set after the element is connected to the DOM, in case the Accordion item has "open on load"
                if (!this.settings.animationDuration) this.GetAnimationDuration();

                if (newValue !== null) {
                    this.setAttribute('aria-expanded', 'true');
                    this.AnimateHeight({ expand: true });

                } else {
                    this.setAttribute('aria-expanded', 'false');
                    this.AnimateHeight({ expand: false });
                }
            }
        }

        // Add a11y attributes
        SetA11yAttributes() {
            this.setAttribute('role', 'heading');
            this.setAttribute('aria-level', '3');
            this.setAttribute('aria-expanded', 'false');
        }

        // Add event listeners
        AddEventListeners() {
            this.addEventListener('click', this.Click.bind(this));

            if (this.settings.clickOutsideClose) document.addEventListener('click', this.ClickOutside.bind(this));

            // Add close-others event listener
            if (this.settings.groupId) {
                document.addEventListener(`close-others-${ this.settings.groupId }`, this.CloseOthers.bind(this));
            }


            // if the user refreshing the page with the accordion open?
            window.addEventListener('beforeunload', this.deleteOpenCookie.bind(this));
        }

        // Remove event listeners
        RemoveEventListeners() {
            this.removeEventListener('click', this.Click.bind(this));

            if (this.settings.clickOutsideClose) document.removeEventListener('click', this.ClickOutside.bind(this));

            // Remove close-others event listener
            if (this.settings.groupId) {
                document.removeEventListener(`close-others-${ this.settings.groupId }`, this.CloseOthers.bind(this));
            }

            // Remove the event listener that deletes the cookie
            window.removeEventListener('beforeunload', this.deleteOpenCookie.bind(this));
        }

        // Click event
        Click(event) {
            if (event.target.hasAttribute('aria-controls')) {
                this.Toggle();
            }
        }

        ClickOutside(event) {
            if (!this.contains(event.target)) {
                this.removeAttribute('open');
            }
        }

        // Close all other accordions
        CloseOthersEvent() {
            document.dispatchEvent(new CustomEvent(`close-others-${ this.settings.groupId }`,
                {
                    detail: this.settings.id,
                    bubbles: true
                }
            ));
        }

        // Close all other accordions
        CloseOthers(event) {
            if (event.detail !== this.settings.id) {
                this.removeAttribute('open');
            }
        }

        // Toggle the accordion
        Toggle() {
            if (this.hasAttribute('open') === false) {
                this.setAttribute('open', '');

                if (this.settings.setOpenParam) this.setOpenCookie();
                if (this.settings.groupId) {
                    this.CloseOthersEvent();
                }

            } else {
                this.removeAttribute('open');
                if (this.settings.setOpenParam) this.deleteOpenCookie();
            }
        }

        AnimateHeight({ expand = true }) {
            const element = this.querySelector('#' + this.settings.ariaControlsId);

            if (this.settings.animationCloseTimeout) {
                clearTimeout(this.settings.animationCloseTimeout)
            }

            if (expand) {
                element.classList.add('visible');

                element.style.maxHeight = `${ element.scrollHeight }px`;
            } else {

                if (this.settings.animationOpenTimeout) {
                    clearTimeout(this.settings.animationOpenTimeout)
                }

                element.style.maxHeight = `${ element.scrollHeight }px`;
                void element.scrollHeight;
                element.style.maxHeight = '0';

                this.settings.animationCloseTimeout = setTimeout(() => {
                    element.classList.remove('visible');
                }, this.settings.animationDuration);
            }
        }

        GetAnimationDuration() {
            const element = this.querySelector('#' + this.settings.ariaControlsId);
            const ms = window.getComputedStyle(element).transitionDuration.includes('ms');

            this.settings.animationDuration = (parseFloat(window.getComputedStyle(element).transitionDuration)) * (!ms ? 1000 : 1)
        }


        setOpenCookie() {
            // Set cookie to remember the open accordion
            document.cookie = `accordion=${ this.settings.id }; path=/;`;
        }

        deleteOpenCookie() {
            // Delete the cookie by setting its expiration date to a past date
            document.cookie = `accordion=${ this.settings.id }; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
        }

        checkOpenCookie() {
            // Check if the accordion item should be open on load
            const cookies = document.cookie.split(';');
            const accordionCookie = cookies.find(cookie => cookie.includes('accordion'));


            if (accordionCookie) {
                const accordionItemId = accordionCookie.split('=')[1];
                if (accordionItemId === this.settings.id) {
                    this.setAttribute('open', '');
                }
            }

        }

    }

    // Define the custom element

    customElements.define('gtc-accordion-item', GtcAccordionItem);
}
